import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { ITask, TaskStatus } from './TasksApi';
import { IFinalizeApplicationDocumentUploadItem } from 'api/types';

export interface ISubmitTaskParams {
  applicationId: string;
  taskId: string;
  taskStatus: TaskStatus;
  uploadItems: IFinalizeApplicationDocumentUploadItem[];
  comment?: string;
}

export interface ITaskDetailsApi {
  submit(params: ISubmitTaskParams): Promise<ITask>;
}

export default class TaskDetailsRestApi extends BaseApi implements ITaskDetailsApi {
  public submit(params: ISubmitTaskParams) {
    return this.fetch<ITask>('/task-details', {
      method: FetchMethodType.PUT,
      body: params,
    });
  }
}
